import {
  put,
  takeLatest,
  takeEvery,
  select,
  all,
  take,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  // compilePaginationObject,
} from 'app/utils/redux/helpers';
import _ from 'lodash';
import history from 'app/routes/history';
import { adminSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { sagaActions } from 'app/ducks/admins/actions';
import { getCurrentAdmin } from 'app/ducks/admins/selectors';
import {
  getOrganisation,
  getAllOrganisations,
  selectOrganisation,
} from 'app/ducks/organisations/actions';
import { OrganisationsActionTypes } from 'app/ducks/organisations/types';
import { AdminsActionTypes as types } from 'app/ducks/admins/types';

function* createAdminSaga(action): any {
  yield put(sagaActions.createAdminPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).admins.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, adminSchema);
    yield put(sagaActions.createAdminSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createAdminFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateAdminSaga(action): any {
  yield put(sagaActions.updateAdminPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).admins.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, adminSchema);

    yield put(sagaActions.updateAdminSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateAdminFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getAdminSaga(action): any {
  yield put(sagaActions.getAdminPending());
  const [error, response] = yield (yield TeammoApi(yield select())).admins.show(
    action.payload.adminId,
  );
  // console.log(response);

  if (response) {
    const normalizedResponse = normalize(response, adminSchema);
    yield put(sagaActions.getAdminSuccess(normalizedResponse));

    const hardcodedOrgId = yield select(
      (state) => state.authentication.organisationId,
    );
    const admin = yield select((state) => getCurrentAdmin(state));
    const regularOrgId = admin.organisations[0] !== undefined
      ? admin.organisations[0].id
      : undefined;
    const orgId = _.isEmpty(hardcodedOrgId) ? regularOrgId : hardcodedOrgId;
    if (admin.roleType === 'teammo-admin') {
      yield put(yield getAllOrganisations());
      yield take(
        OrganisationsActionTypes.GET_ALL_ORGANISATIONS_SUCCESS,
      );

      yield put(yield getOrganisation(orgId));
    } else {
      yield put(yield getOrganisation(orgId));
    }

    if (action.payload.redirectDashboard) {
      history.push('/');
    }

    return normalizedResponse.entities.admins[normalizedResponse.result];
  }
  yield put(
    handleError(
      error,
      sagaActions.getAdminFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

// function* getAllAdminsSaga(action): any {
//   yield put(
//     sagaActions.getAllAdminsPending(action.payload.compile ? action.payload.pagination : {}),
//   );
//   yield put(loadingStart());

//   const paginationObject = action.payload.compile
//     ? compilePaginationObject(yield select((state) => state.admins.pagination))
//     : action.payload.pagination;

//   const [error, response] = yield (yield TeammoApi(yield select())).admins.list(
//     paginationObject,
//   );

//   if (response) {
//     const normalizedResponse = normalize(response, adminListSchema);

//     yield put(
//       sagaActions.getAllAdminsSuccess(normalizedResponse, response.meta),
//     );
//     yield put(loadingFinish());
//   } else {
//     yield put(
//       error,
//       sagaActions.getAllAdminsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
//     );
//   }
// }

/* ********************************* SAGA WATCHERS ********************************* */

function* createAdminSagaWatcher(): any {
  yield takeLatest(types.CREATE_ADMIN_REQUESTED, createAdminSaga);
}

function* updateAdminSagaWatcher(): any {
  yield takeLatest(types.UPDATE_ADMIN_REQUESTED, updateAdminSaga);
}

function* getAdminSagaWatcher(): any {
  yield takeEvery(types.GET_ADMIN_REQUESTED, getAdminSaga);
}

// function* getAllAdminsSagaWatcher(): any {
//   yield takeEvery(types.GET_ALL_ADMINS_REQUESTED, getAllAdminsSaga);
// }

export default function* root(): any {
  yield all([
    createAdminSagaWatcher(),
    updateAdminSagaWatcher(),
    getAdminSagaWatcher(),
    // getAllAdminsSagaWatcher(),
  ]);
}
